import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-05/lesson-08/task-01";

const task: Slide = {
  titleHtml:
    "Group the various types of sound absorbers according to the frequency range in<br>which they absorb the most sound energy by dragging their images to one of the<br>groups below. All the displayed sound absorbers are built in front of a hard surface.",
  description: "Drag and drop elements.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
